// pages/login.js
import LoginOrSignup from "../components/common/login";

export default function Login() {
  
  return (
    <LoginOrSignup isSignup={false} />
  )
}
